import { makeStyles, ThemeProvider } from '@material-ui/core/styles';
import { ReactNode } from 'react';
import { redesignMuiTheme } from './muiTheme';

const useRedesignGlobalStyles = makeStyles({});

type RedesignThemeProviderProps = {
  children: ReactNode;
};

const RedesignThemeProvider = ({ children }: RedesignThemeProviderProps) => {
  useRedesignGlobalStyles();

  return (
    <ThemeProvider theme={redesignMuiTheme}>
      <div className="redesign-root">{children}</div>
    </ThemeProvider>
  );
};

export default RedesignThemeProvider;
